import { generateEventsDefinition } from '@guiker/event'

import { Transfer, TransferWriteModel } from '../../entity'
import { baseEvent } from '../base'

export const { TransferEventsDefinition } = generateEventsDefinition({
  ...baseEvent,
  entity: 'TRANSFER',
  data: null as unknown as Transfer,
  eventTypes: {
    FAILED: 'FAILED',
    PAID: 'PAID',
    REVERSED: 'REVERSED',
    REVERSAL_RECTIFIED: 'REVERSAL_RECTIFIED',
  } as const,
  write: {
    data: null as unknown as TransferWriteModel,
  },
})
